"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollToTop = void 0;
var react_1 = __importDefault(require("react"));
var react_scroll_up_1 = __importDefault(require("react-scroll-up"));
var style = {
    position: 'fixed',
    cursor: 'pointer',
    transitionDuration: '0.2s',
    transitionTimingFunction: 'linear',
    transitionDelay: '0s',
    bottom: 20,
    right: 20,
    zIndex: 9999,
};
var ScrollToTop = function (props) {
    var _a = props.showUnder, showUnder = _a === void 0 ? 10 : _a, children = props.children;
    return (react_1.default.createElement(react_scroll_up_1.default, { style: style, showUnder: showUnder }, children));
};
exports.ScrollToTop = ScrollToTop;
exports.default = exports.ScrollToTop;
